import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { Typography } from "@mui/material";
import { RootState } from "../../../app/store";
import { mqttActions } from "../../../redux/mqtt/mqttSlice";
import { aeroActions } from "../../../redux/aero/aeroSlice";


export default function AdsbStop({ adsbTx }: { adsbTx: boolean }) {
    const dispatch = useDispatch();
    const mission = useSelector((state: RootState) => state.mission.active);
    const isAdmin = useSelector((state: RootState) => state.auth.level === "superuser" || state.auth.level === "admin");


    const handleClick = useCallback(() => {
        dispatch(mqttActions.publish({ topic: `planet/${mission}/adsb/modeS/tx`, payload: JSON.stringify({tx: !adsbTx, mission}), retain: true }))
        dispatch(aeroActions.adsb_tx({tx: !adsbTx, mission}));
    }, [dispatch, mission, adsbTx]);

    return (
        <Stack direction="row" justifyContent="space-between" margin={1} marginBottom={0}>
            <Typography variant="body2" sx={{ fontSize: '1rem', whiteSpace: "nowrap" }}>Tx to ground</Typography>
            {isAdmin ?
                <Button
                    variant="outlined"
                    color={adsbTx ? "info" : "error"}
                    onClick={handleClick} disabled={!isAdmin}
                >
                    <Typography variant="body1" sx={{ fontSize: '1rem', whiteSpace: "nowrap" }}>
                        {adsbTx ? "Stop" : "Start"}
                    </Typography>
                </Button>
            :
                <Typography variant="body1" sx={{ fontSize: '1rem', whiteSpace: "nowrap" }} color={adsbTx ? "#03b1f5" : "#ff3333"}>
                    {adsbTx ? "Sending" : "Stopped"}
                </Typography>
            }
        </Stack>
    );
};